import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const ScenariosApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "Scenarios" */ "./ScenariosApp");
    return { default: namedExport.ScenariosApp };
});

export const Scenarios: TeamAppConfig = {
    title: "MaaS Onboarding",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "This page provides ability to onboard, manage, and configure scenarios.",
    team: "OSP",
    publicId: "ExchangeOSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: ScenariosApp,
    path: "/maasonboarding"
};
